export default "__VITE_ASSET__BpxDt1tX__"